import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface BusinessDashboardRecord {
  id: string;
  payment_date: string;
  property_id: string;
  property_short_name?: string;
  description?: string;
  expense_description?: string;
  total_payment: number;
  income_type?: string;
  expenses_type?: string;
}

export interface MonthlyData {
  month: string;
  amount: number;
  records: BusinessDashboardRecord[];
}

export interface BusinessDashboardMetrics {
  monthly_income: MonthlyData[];
  monthly_expenses: MonthlyData[];
  monthly_profit: { month: string; amount: number }[];
  total_income: number;
  total_expenses: number;
  net_profit: number;
}

export const useBusinessDashboardMetrics = (
  year: number,
  propertyIds?: string[],
  organizationIds?: string[]
) => {
  return useQuery({
    queryKey: ["business-dashboard-metrics", year, propertyIds, organizationIds],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_business_dashboard_metrics", {
        p_year: year,
        p_property_ids: propertyIds?.length ? propertyIds : null,
        p_organization_ids: organizationIds?.length ? organizationIds : null,
      });

      if (error) throw error;
      return data as unknown as BusinessDashboardMetrics;
    },
  });
};
